import Head from "next/head";
import {
  defaultSocialImage,
  getCanonicalUrl,
  SITE_NAME,
  SITE_ORIGIN,
  type StaticPublicPage,
} from "@/lib/public-seo";

type SocialImage = {
  alt: string;
  height: number;
  path: string;
  width: number;
};

export function PublicPageHead({
  page,
  structuredData,
  image = defaultSocialImage,
}: {
  image?: SocialImage;
  page: StaticPublicPage;
  structuredData?: unknown;
}) {
  const canonical = getCanonicalUrl(page.path);
  const imageUrl = `${SITE_ORIGIN}${image.path}`;

  return (
    <Head>
      <title>{page.title}</title>
      <meta name="description" content={page.description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_CA" />
      <meta property="og:title" content={page.title} />
      <meta property="og:description" content={page.description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:width" content={String(image.width)} />
      <meta property="og:image:height" content={String(image.height)} />
      <meta property="og:image:alt" content={image.alt} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={page.title} />
      <meta name="twitter:description" content={page.description} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="twitter:image:alt" content={image.alt} />
      {structuredData !== undefined && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(structuredData).replace(/</gu, "\\u003c"),
          }}
        />
      )}
    </Head>
  );
}
